import { useRef } from "react";
import { random } from "lodash";

import useAdProductsOfType from "./useAdProductsOfType";
import { selectAdProduct } from "../selectors";

export default function useRotatedAdProductOfType(type) {
  const randNumRef = useRef(random(1, 100));

  const { adProducts: adProductsOfType, ...queryInfo } = useAdProductsOfType(
    type,
  );

  return {
    ...queryInfo,
    adProduct: selectAdProduct(adProductsOfType, randNumRef.current),
  };
}
